import type { PostOfficeEnvironmentValues } from '@atlassian/post-office-context';

import RemotePostOfficePlugin from './plugin';

class PluginRegistry {
	public static getRegistry(): PluginRegistry {
		if (window.postOfficePluginRegistry === undefined) {
			window.postOfficePluginRegistry = new PluginRegistry();
		}

		return window.postOfficePluginRegistry;
	}

	private readonly registry: Map<string, RemotePostOfficePlugin> = new Map();

	public getPluginForPlacement(
		placementId: string,
		environmentContext: PostOfficeEnvironmentValues,
	): RemotePostOfficePlugin {
		const pluginKey = `${placementId}--${environmentContext.currentEnv}`;

		const registryPlugin = this.registry.get(pluginKey);
		if (registryPlugin) {
			return registryPlugin;
		}

		const plugin = new RemotePostOfficePlugin(placementId, environmentContext);

		this.registry.set(pluginKey, plugin);

		return plugin;
	}
}

export default PluginRegistry;

declare global {
	interface Window {
		postOfficePluginRegistry?: PluginRegistry;
	}
}
